import React from 'react';
import './PageList.css';

/**
 * columns: [{ label: string, style?: object, className?: string }]
 * children: <tr> 요소들 (tbody 행)
 * totalPages: number
 * currentPage: number
 * onPageChange: (page: number) => void
 * emptyMessage: string (optional)
 */
function PageList({ columns = [], children, totalPages = 1, currentPage = 1, onPageChange, emptyMessage = '데이터가 없습니다.' }) {
  const hasRows = React.Children.count(children) > 0;

  return (
    <>
      {!hasRows ? (
        <div className="page-list-empty">
          <p>{emptyMessage}</p>
        </div>
      ) : (
        <>
          <div className="table-responsive">
            <table className="table table-nowrap align-middle table-hover mb-0">
              <thead className="table-light">
                <tr>
                  {columns.map((col, i) => (
                    <th key={i} style={col.style} className={col.className}>
                      {col.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>{children}</tbody>
            </table>
          </div>

          {totalPages > 1 && (
            <nav className="page-list-pagination">
              <ul className="pagination justify-content-center">
                {Array.from({ length: totalPages }, (_, i) => (
                  <li key={i + 1} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => onPageChange(i + 1)}>
                      {i + 1}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>
          )}
        </>
      )}
    </>
  );
}

export default PageList;
